import { Typography, styled } from "@mui/material";

export const Header = styled(Typography)<{
  type: "warning" | "error" | "normal";
}>(({ theme }) => ({
  variants: [
    {
      props: {
        type: "warning",
      },
      style: {
        color: theme.palette.warning.main,
      },
    },
    {
      props: {
        type: "error",
      },
      style: {
        color: theme.palette.error.main,
      },
    },
    {
      props: {
        type: "normal",
      },
      style: {
        color: theme.palette.text.primary,
      },
    },
  ],
}));
